import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

import { pageWrapperSizeAtom } from '../store/index.atom';

interface Props {
  originalWidth: number;
  originalHeight: number;
}

const useHandleResizedImage = ({ originalHeight, originalWidth }: Props) => {
  const pageWrapperSize = useAtomValue(pageWrapperSizeAtom);

  /*반응형에 따른 이미지 사이즈 구하기 위한 로직 */
  const resizedImageSize = useMemo(() => {
    const pageWrapperAspectRatio =
      pageWrapperSize.width / pageWrapperSize.height;
    const imageAspectRatio = originalWidth / originalHeight;

    /*CASE1: pdf 이미지의 방향이 가로일 때  */
    if (imageAspectRatio > pageWrapperAspectRatio) {
      const width = pageWrapperSize.width;
      const height = pageWrapperSize.width / imageAspectRatio;
      return {
        widthRatio: width / originalWidth,
        heightRatio: height / originalHeight,
        xMargin: 0,
        yMargin: (pageWrapperSize.height - height) / 2,
        width,
        height,
      };
    }

    /*CASE2: pdf이미지 방향이 세로일 때 */

    const width = pageWrapperSize.height * imageAspectRatio;
    const height = pageWrapperSize.height;
    return {
      widthRatio: width / originalWidth,
      heightRatio: height / originalHeight,
      xMargin: (pageWrapperSize.width - width) / 2,
      yMargin: 0,
      width,
      height,
    };
  }, [pageWrapperSize, originalWidth, originalHeight]);

  return {
    resizedImageSize,
  };
};

export default useHandleResizedImage;
